import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";

/**
 * @returns true if the placement query param starts with fb
 */
export const isComingFromFBPaidAds = (): boolean => {
  const location = getLocation();
  const placement = parseQueryParams(location?.search ?? "").get("placement");
  return (placement?.startsWith("fb") || placement?.startsWith("ig")) ?? false;
};
